import type { Profile } from "@shyne/shared/api";
import type { SessionUser } from "@/models/user.model";

export const toSessionUser = (profile: Profile, authId: string): SessionUser => ({
  id: profile.id,
  authId,
  name: profile.name,
  email: profile.email,
  phone: profile.phone,
  description: profile.description,
  image: profile.avatar,
});
